import { Service, Plan, Testimonial } from '../types';

export const services: Service[] = [
  {
    id: 1,
    title: 'Preparación para el nacimiento',
    description: 'Te acompaño a transitar el embarazo con información clara, contención emocional y ejercicios corporales, para llegar al nacimiento con las herramientas necesarias.',
    icon: 'heart',
  },
  {
    id: 2,
    title: 'Acompañamiento en el puerperio',
    description: 'Te acompaño en el puerperio con escucha, presencia y contención, trabajando herramientas para la lactancia, el descanso, el vínculo con tu bebé y también para cuidar tu bienestar emocional',
    icon: 'baby',
  },
  {
    id: 3,
    title: 'Acompañamiento al duelo perinatal',
    description: 'Te acompaño creando juntas un espacio seguro, donde el dolor tiene lugar y tu historia puede ser nombrada, para transitar el duelo con amor, presencia y respeto',
    icon: 'heartHandshake',
  },
  {
    id: 4,
    title: 'Consultas Personalizadas',
    description: 'Sesiones individuales para abordar preocupaciones específicas relacionadas con cualquier etapa del embarazo, parto o posparto.',
    icon: 'messageCircle',
  },
];

export const plans: Plan[] = [
  {
    id: 1,
    name: 'Acompañamiento Completo',
    subtitle: '',
    previousPrice: '$12.000',
    price: '$10.000',
    previousPriceDolars: 'US$ 340',
    priceDolars: 'US$ 250',
    description: 'La más elegida: equilibrio entre profundidad, acompañamiento e información.',
    features: [
      '6 encuentros de 2 horas cada uno.',
      'Información completa sobre embarazo, parto y posparto.',
      'Ejercicios físicos para aliviar molestias y conectar con el cuerpo (basados en el método Frida Kaplan, embarazo y nacimiento eutónico).',
      'Espacio de contención emocional.',
      'Participación del compañero/a o referente afectivo.',
      'Seguimiento personalizado por WhatsApp.'
    ],
    isPopular: true,
    isPromotion: true
  },
  {
    id: 2,
    name: 'Acompañamiento Esencial',
    subtitle: '',
    previousPrice: '$9.500',
    price: '$7.500',
    previousPriceDolars: 'US$ 240',
    priceDolars: 'US$ 197',
    description: 'Ideal si queres un acompañamiento más breve pero significativo. \n \n\n\n ',
    features: [
      '4 encuentros de 2 horas cada uno',
      'Información clave sobre embarazo, nacimiento y posparto.',
      'Ejercicios físicos esenciales',
      'Acompañamiento emocional.',
      'Participación del compañero/a o referente afectivo.',
    ],
    isPromotion: true
  }
];

export const plansB: Plan[] = [
  {
    id: 1,
    name: 'Acompañamiento en el puerperio',
    previousPrice: '$10.000',
    price: '$8.000',
    previousPriceDolars: 'US$ 250',
    priceDolars: 'US$ 200',
    description: 'Mi servicio está diseñado para brindarte un espacio de escucha, información y sostén emocional, adaptado a tus necesidades.',
    features: [
      '3 encuentros en tu hogar.',
      'Herramientas para el bienestar físico y emocional.',
      'Recursos prácticos para la organizacion diaria y la crianza.',
      'Apoyo en temas como lactancia, vínculo con el bebé y autocuidado.',
      'Seguimiento personalizado por WhatsApp para que te sientas sostenida en el día a día.'
    ],
    isPromotion: true
  },
  {
    id: 2,
    name: 'Acompañamiento al duelo perinatal y neonatal',
    previousPrice: '$6.500',
    price: '$4.500',
    previousPriceDolars: 'US$ 160',
    description: 'Acompañamiento con herramientas puntuales.',
    features: [
      'Primer encuentro: Historia del bebé, tiempo compartido. Damos lugar al dolor.',
      'Segundo encuentro: Creamos caja del recuerdo. Damos lugar a la maternidad/paternidad tal cual fue',
      'Tercer encuentro: Repasamos el cuaderno del dolor y la caja del recuerdo'
    ],
    isPromotion: false
  },
];

export const testimonials: Testimonial[] = [
    {
    id: 1,
    name: '',
    youtubeId: 'gMJ6kqYhDsc',
    poster: 'https://images.unsplash.com/photo-1524504388940-b1c1722653e1?auto=format&fit=crop&w=400&q=80'
  },
  {
    id: 2,
    name: 'Miguela y Guillermo',
    role: 'Servicio de Doula',
    content: 'Haber contado con el acompañamiento de Marha fue de las mejores decisiones durante mi embarazo. Cada encuentro fue especial y nos hacía muy bien como pareja tanto por lo que aprendíamos, como también para entender de qué forma estaba viviendo el otro esa etapa y por ende, entendernos mejor entre nosotros. Cada mañana de jueves compartida nos ayudó a llegar al parto con seguridad, información y mucha paz. Le agradeceremos siempre su calidez, su amabilidad para explicarnos las mil dudas que le preguntábamos, su capacidad para adaptarse y ayudarnos cuando había crisis emocional de por medio y las risas infaltables de cada encuentro. Realmente agradezco al universo que nos haya acompañado para recibir a Delfi y sin duda la recordaremos siempre con muchísimo cariño. Ojalá todas las mujeres pudieran tener una doula que las acompañara así, desde la sabiduría y el amor.',
  },
  {
    id: 3,
    name: '',
    youtubeId: 'TBJ1yIbrFuA',
    poster: 'https://images.unsplash.com/photo-1514996937319-344454492b37?auto=format&fit=crop&w=400&q=80'
  },
  {
    id: 4,
    name: 'Eugenia y Germán',
    role: 'Preparación para el nacimiento online',
    content: 'Para nosotros fueron muy importantes los talleres de preparación del nacimiento. Como padres primerizos era todo nuevo y en ellos pudimos conversar muchas inquietudes. Los disfrutamos mucho y nos sentimos muy apoyados y acompañados en la hermosa etapa del embarazo.. Nos encantó la claridad y calidez humana de Marha. Se los recomendamos a todos los futuros papás como un hermoso momento de conexión.'
  },
 {
    id: 5,
    name: 'Flor y Diego.',
    role: 'Preparación para el nacimiento',
    content: 'Hola somos Flor y Diego, ma-padres de Simone. Y hoy queremos dejar plasmada en breves palabras nuestra experiencia con Marha ❤️ ​Cuando transitamos nuestra gestación decidimos contactar a Marha. A mi como mamá Me hacía mucha ilusión poder transitar mi segundo embarazo acompañada y sostenida por alguien que tuviera las herramientas adecuadas para eso. En ese entonces el objetivo principal era, llegar al parto tranquilos, con saberes que nos dieran paz. ​Que ilusos, porque al iniciar los talleres ambos obtuvimos mucho más que eso, Marha nos brindo cada semana un lugar seguro y amoroso en dónde encontrarnos los tres y nosotros como pareja. Dónde brotaban muchas veces emociones profundas que como gestantes muchas veces no se les encuentra el lugar adecuado en el día a día. Se volvió un ritual el refugio de Marha donde cada encuentro nos llevábamos mucho más que paz y tranquilidad, nos llevamos siempre conocimientos que nos hizo crecer como familia y aumentar nuestras herramientas del día a día para esta llegada tan esperada. ​Sin dudas recomendamos el espacio de acompañamiento para familias gestantes que nos brindó, Diego como padre pudo encuentro tras encuentro lograr sumergirse en este mundo y poder tener claras situaciones que como padre y compañero en la gestación y parto le iban a tocar y ponerle voz a sus dudas internas, dejando firme su postura y teniendo la seguridad absoluta de que podía y era súper capaz de emplear ese rol. ​Simone dió señales un mes antes de que estaba preparado para llegar y con el correr de las semanas fue dando señales más claras, preparándonos para todo esto y con una intuición perfecta Marha decidió hacer nuestro último encuentro y hacer una meditación que nos llevará a despedir la panza. La hicimos, fue mágica y al otro día Simone llegó a este mundo, con dos seres llenos de herramientas, dudas disipadas, unidos en amor y sobre todo con mucha tranquilidad y seguridad, a pesar del sistema que muchas veces nos llena de inseguridad. ​En un mundo que muchas veces corre y exige; mamá y papá se disponen a traer vida y sin dudas es fundamental sentir que hay un pedacito de tiempo en dónde todo se ve en calma y encontramos ese lugar. Y eso es lo que nos brindó el alma de Marha. ​Estamos super agradecidos y nos llevamos frases que nos quedaron para siempre y hoy queremos compartirles una de las tantas que nos regaló Marha: ​"Tarde es nunca"'
  },
  {
    id: 6,
    name: '',
    youtubeId: 'zTfZvTGppXU',
    poster: ''
  },
  {
    id: 7,
    name: 'Ana Clara y Joaquin.',
    role: 'Preparación para el nacimiento',
    content: 'Durante el embarazo elegimos realizar los talleres de preparación al nacimiento con Marha. Entre varias propuestas que encontramos la elegimos porque desde un comienzo fluyó, nos comunicamos y nos respondió enseguida de forma amorosa con información concreta sobre el servicio que brindaba y la propuesta se ajustaba a lo que buscábamos. La experiencia fue muy enriquecedora. Desde el primer encuentro, sentimos un trato cálido y muy respetuoso. Cada día de taller se convirtió en un espacio seguro donde intercambiar y poder expresar nuestro sentir en cada etapa que estábamos viviendo, y también nuestras dudas y necesidades. Cada detalle daba cuenta del pienso y la dedicación que hay detrás, contemplando nuestras particularidades como familia y también las individualidades. Los talleres nos brindaron la información justa. Contemplando desde aquello vinculado a la fisiología del cuerpo, la dimensión psicoemocional y también aspectos del marco legal, con un enfoque en  derechos que nos  ayudó a estar preparados y más seguros el día del nacimiento. Además incorporó ejercicios corporales y otras dinámicas en pareja para conectar desde otro lugar con el embarazo, lo que nos ayudó a fortalecer nuestra comunicación. Elegimos la modalidad de 3 encuentros intensivos y lejos de hacerse pesado cada encuentro pasaba volando y realmente lo disfrutamos. Marha llegaba a casa cada sábado que tuvimos encuentro con una sonrisa y una disponibilidad que nos hacía sentir que podía evacuar todas nuestras dudas... Y hacia parecer que nos conocíamos hace mucho más tiempo. Los talleres de preparación con Marha son sin dudas un espacio cálido y seguro, una experiencia que recomendamos para hacerla en pareja, sola o con quien elijas ya que seguro ella adaptará la propuesta a las necesidades que tengas. Abrazo Marha, acá una familia que siempre te va a agradecer y recordar con cariño 💜'
  }
];

export const testimonials2: Testimonial[] = [
  {
    id: 1,
    name: '',
    role: 'Preparación para el nacimiento online',
    content: 'Excelente taller, informativo y ameno. Me encanto la perspectiva desde donde es brindado además del material de consulta enviado a parte del taller. Aporta tranquilidad y mejor preparación para un momento tan importante y a la vez tan demandante física y emocionalmente. ¡Muy recomendable!'
  },
  {
    id: 2,
    name: '',
    role: 'Preparación para el nacimiento online',
    content: 'Hicimos el taller de manejo del dolor en el parto con mi pareja, y nos ayudó un montón. Nos brindó muchas herramientas para afrontar el momento del parto con más información, seguridad y confianza. Super recomendable, un taller hermoso!'
  },
  {
    id: 3,
    name: '',
    role: 'Preparación para el nacimiento online',
    content: 'Hicimos el taller de manejo del dolor en el parto con Marha. Nos gustó mucho, fue muy clara con respecto al contenido, abierta a aclarar todas las dudas que teníamos al respecto y nos llevamos muchas herramientas para afrontar el trabajo de parto. Sin dudas lo recomendamos! Muchas gracias!!'
  },
  {
    id: 4,
    name: 'Macarena y Leandro',
    role: 'Preparación para el nacimiento online',
    content: 'Antes del taller estábamos con muchas dudas y miedos, conectamos muy fácil con tu energía y eso nos permitió tener la confianza para hacer esas preguntas que nos daban vergüenza. Valoramos mucho las herramientas brindadas y destacamos la calidez que tiene, nos sentimos cómodos y sobre todo dos contenidos . Gracias'
  },
  {
    id: 5,
    name: '',
    role: 'Preparación para el nacimiento online',
    content: 'Participar de este taller me brindó algo que es fundamental para este enorme proceso que es el embarazo, hablar del dolor que es inevitable entre otras mujeres que también están pasando por este proceso, me parece importante entender el dolor como un acercamiento a conocer a nuestro beb@ y eso me permitió empezar a pensarlo desde otro punto de vista, un dolor que conecta con tu bebé. Además de la información a la cual accedimos sobre cuándo consultar, qué esperar y técnicas de respiración. Muy clara Marha, amable y atenta gracias'
  },
  {
    id: 6,
    name: '',
    role: 'Preparación para el nacimiento online',
    content: 'Participar del taller de manejo de dolor en el parto me permitió darle claridad a un proceso que personalmente me genera mucha incertidumbre, y me animó a dejar de asociar el dolor como algo esencialmente negativo. Esto me brindó más calma y claridad con qué esperar, y qué hacer, y por sobre todo confiar en el proceso y en escuchar mi cuerpo. Gracias Marha por tu dedicación y todo los detalles!'
  },
  {
    id: 7,
    name: '',
    role: 'Preparación para el nacimiento online',
    content: 'La verdad una experiencia muy enriquecedora ya que llegué al taller con varias dudas y salí de él con muchas cosas que no sabía que podía necesitar y todas mis dudas claras. Me dio mucha tranquilidad y más seguridad para afrontar lo que se está por venir. Y la charla de hacerse cargo la pareja en momentos que nosotras estamos saturadas no sabía que era tan necesaria. Me aclaró el gran rol que puede tener y el sostén que nos puede dar en ese momento. Me llevo grandes herramientas del taller. Nada más que agregar que mil gracias.'
  },
];
